<template lang="html">
  <ul :class="{'fixed-height pr-2': popUp }">
    <li v-for="(alert, index) in alerts" :key="`alert${index}`" :class="{' font-weight-medium': popUp }">
      <slot v-bind="{ alert, index }">
        <template v-if="verbose">
          <span class="text-subtitle-2">
            {{ alert.code }} - {{ capitalize(alert.title) }}
          </span>
          <br />
          <span class="text-body-2">
            <template v-if="alert.meta">
              {{ capitalize(alert.meta.exception) }}
            </template>
            <template v-else>
              {{ capitalize(alert.detail) }}
            </template>
          </span>
        </template>
        <template v-else>
          {{ capitalize(alert.detail || alert) }}
        </template>
      </slot>
    </li>
  </ul>
</template>

<script>
import { capitalize } from 'lodash';

export default {
  name: 'AlertListItems',
  props: {
    alerts: {
      type: Array,
      default: () => [],
    },
    verbose: {
      type: Boolean,
      default: false,
    },
    popUp: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    capitalize,
  }
};
</script>

<style lang="css" scoped>
.fixed-height {
  max-height: 60px;
  overflow-y: auto;
}
</style>